import { ROUTE_PATH } from '@/constants/routePath'
import classnames from 'classnames/bind'
import Link from 'next/link'
import { ReactNode } from 'react'
import AboutPageLayout from '../utils/AboutPageLayout'
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type TermItemType = {
  title: string
  description: ReactNode
}

const terms: TermItemType[] = [
  {
    title: '第 1 条（目的）',
    description:
      '本規約は、ライブモールクラブ株式会社（以下「運営者」という）が提供する Live Mall Club（以下「本プラットフォーム」という）の利用に関し、消費者（以下「会員」という）が 遵守すべき事項を定めるものです。',
  },
  {
    title: '第 2 条（会員登録）',
    description: (
      <ol>
        <li>本プラットフォームを利用するには、運営者が定める手続きに従い会員登録を行う必要があります。</li>
        <li>会員は、登録情報に虚偽のない正確な情報を提供しなければなりません。</li>
        <li>会員は、登録情報に変更が生じたときは、速やかに変更手続を行うものとします。</li>
        <li>会員資格は、運営者の承認を得た場合にのみ有効となります。</li>
      </ol>
    ),
  },
  {
    title: '第 3 条（サービスの利用）',
    description: (
      <ol>
        <li>会員は、本プラットフォームを通じてライブコマース形式で商品を購入できます。</li>
        <li>
          商品の購入契約は、会員と出店者の間で成立するものとし、運営者は取引に関与しません。また、出店者との間に生じたトラブルは、出店者との間で解決するものとします。
        </li>
        <li>会員は、商品の返品・交換ポリシーを確認したうえで購入するものとします。</li>
      </ol>
    ),
  },
  {
    title: '第 4 条（個人情報保護方針）',
    description: (
      <ol>
        <li>
          運営者は、会員の個人情報を適切に管理し、以下の目的で利用します。
          <ul>
            <li>本プラットフォームの運営・提供</li>
            <li>購入手続きおよび配送のための情報管理</li>
            <li>問い合わせ対応やカスタマーサポート</li>
            <li>本プラットフォームのサービス改善</li>
            <li>マーケティングやプロモーション（会員の同意がある場合）</li>
          </ul>
        </li>
        <li>収集するデータの種類:</li>
        <ul>
          <li>氏名、住所、電話番号、メールアドレス、購入履歴</li>
          <li>支払情報（クレジットカード情報は決済代行会社を通じて処理されるため、運営者は保持しない）</li>
        </ul>
        <li>運営者は、以下の場合を除き、会員の個人情報を第三者に提供しません。</li>
        <ul>
          <li>会員の同意がある場合</li>
          <li>法令に基づく開示要求があった場合</li>
          <li>サービス提供のために必要な範囲で業務委託先に開示する場合</li>
        </ul>
      </ol>
    ),
  },
  {
    title: '第 5 条（免責事項）',
    description: (
      <ol>
        <li>ライブ配信における発言内容について、運営者は責任を負いません。</li>
        <li>会員が購入した商品の品質、性能、適合性については、出店者が責任を負います。</li>
        <li>システム障害、通信エラー、不可抗力（自然災害など）によるサービス停止により会員に損害が生じた場合、運営者は一切の責任を負いません。</li>
      </ol>
    ),
  },
  {
    title: '第 6 条（返品・キャンセルポリシー） ',
    description: (
      <ol>
        <li>返品・交換の条件</li>
        <ul>
          <li>商品到着後〇日以内にカスタマーサポートへ連絡。</li>
          <li>初期不良・破損の場合のみ交換対応（送料は出店者負担）。</li>
          <li>開封済み、使用済み商品の返品不可。</li>
        </ul>
        <li>キャンセル</li>
        <ul>
          <li>商品発送前に限りキャンセル可能。</li>
          <li>予約商品・オーダーメイド商品はキャンセル不可。</li>
        </ul>
      </ol>
    ),
  },
  {
    title: '第 7 条（禁止事項）',
    description: (
      <div>
        会員は、以下の行為を行ってはなりません。
        <ol>
          <li>虚偽情報の登録または第三者の情報を不正利用する行為</li>
          <li>運営者、出店者、他の会員に対する誹謗中傷または迷惑行為</li>
          <li>本プラットフォームの運営を妨害する行為</li>
          <li>不正アクセスや有害プログラムの送信</li>
        </ol>
      </div>
    ),
  },
  {
    title: '第 8 条（会員資格の停止・解除）',
    description: (
      <ol>
        <li>運営者は、会員が本規約に違反した場合、アカウントの停止または解除を行うことができます。</li>
        <li>会員は、退会を希望する場合、所定の手続きにより退会を申し出ることができます。</li>
      </ol>
    ),
  },
  {
    title: '第 9 条（特定商取引法に基づく表示）',
    description: (
      <ol>
        <li>販売事業者の名称、所在地、連絡先は、各出店者の商品ページに表示されます。</li>
        <li>商品の販売価格、送料、支払方法、引渡時期、返品・交換の条件についても各商品ページに明記されます。</li>
      </ol>
    ),
  },
  {
    title: '第 10 条（準拠法および管轄）',
    description: (
      <div>本規約は、必要に応じて改定されることがあります。改定後の規約は、本プラットフォーム上で告知することにより、効力を生じます。</div>
    ),
  },
  {
    title: '第 11 条（準拠法および管轄） ',
    description: (
      <div>
        本規約は日本法に基づき解釈され、紛争が生じた場合は、東京地方裁判所を専属管轄裁判所とします。
        <ul>
          附則
          <li>本規約は、2025 年〇月〇日より施行します。</li>
          <li>運営者は、本規約を随時改定できるものとし、改定後の規約はプラットフォーム上で告知することにより効力を生じます。</li>
        </ul>
      </div>
    ),
  },
]

const Terms = () => {
  return (
    <AboutPageLayout>
      <AboutPageLayout.SectionTitle>Live Mall Club 消費者向け規約</AboutPageLayout.SectionTitle>
      <div className={cx('terms')}>
        {terms.map((term, index) => (
          <div key={index}>
            <AboutPageLayout.SectionTitle>{term.title}</AboutPageLayout.SectionTitle>
            <div>{term.description}</div>
          </div>
        ))}
      </div>
      <Link href={ROUTE_PATH.ABOUT_PRIVACY_POLICY} className={cx('link')}>
        Live Mall Club Privacy Policy
      </Link>
    </AboutPageLayout>
  )
}

export default Terms
